
import Vue from 'vue'
import vButton from '@/components/vButton.vue'
import vBackButton from '@/components/vBackButton.vue'
import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
@Component({ name: 'vPopup', components: { vButton, vBackButton } })
export default class indexView extends Vue {
  @Prop({ default: false }) showCloseIcon?: string
  @Prop({ default: '' }) buttonsStyle?: string
  @Prop({ default: '' }) popDescStyle?: string
  @Prop({
    type: String,
    default: '',
  })
  title!: string

  @Prop({
    type: Boolean,
    default: false,
  })
  isShow!: boolean

  @Prop({
    type: String,
    default: '',
  })
  text!: string

  @Prop({
    type: String,
    default: '',
  })
  cancelLabel!: string

  @Prop({
    type: String,
    default: '',
  })
  confirmLabel!: string

  @Prop({
    type: Number,
    default: 1,
  })
  cancelWidth!: number

  @Prop({
    type: Number,
    default: 1,
  })
  confirmWidth!: number

  @Prop({
    type: Number,
    default: 2.73,
  })
  dialogHeight!: number

  beforeMount() {
    this.$nextTick(() => {
      document
        .querySelector('.pop-content')
        ?.setAttribute('style', `height:${this.dialogHeight}rem`)

      document
        .querySelector('.backButton')
        ?.querySelector('.van-button--default')
        ?.setAttribute('style', `width:${this.cancelWidth}rem`)

      const khEl: any = this.$refs.khButton
      khEl
        ?.querySelector('.van-button--default')
        ?.setAttribute('style', `width:${this.confirmWidth}rem`)
    })
  }

  closeOver() {
    this.$emit('closeOver')
  }
  cancel() {
    this.$emit('cancelhandleclick')
  }
  confirm() {
    this.$emit('confirmhandleclick')
  }
}
